import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateDepartment } from "../departmentsThunks";
import {
  setSelectedDepartment,
  setIsEditDepartment,
} from "../departmentsSlice";
import { getAccessType } from "../../../lib/functions";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateDepartmentForm = () => {
  const { modal } = App.useApp();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [form] = useForm();

  const { isEditDepartment, selectedDepartment } = useSelector(
    (state) => state.departments
  );
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("department_entry");
    access_type_set(access);
  }, []);


  useEffect(() => {
    if (isEditDepartment && selectedDepartment) {
      form.setFieldsValue(selectedDepartment);
    } else {
      form.resetFields();
    }
  }, [isEditDepartment, selectedDepartment]);

  const handleCancel = () => {
    dispatch(setSelectedDepartment(null));
    dispatch(setIsEditDepartment(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    try {
      await dispatch(
        createOrUpdateDepartment({
          ...values,
          action: isEditDepartment ? "update" : "create",
          department_id: selectedDepartment?.department_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditDepartment
          ? "Department updated successfully"
          : "Department created successfully",
      });

      dispatch(setSelectedDepartment(null));
      dispatch(setIsEditDepartment(false));

      // ✅ Check if there's a return URL from query params
      const returnUrl = searchParams.get("returnUrl");

      if (returnUrl) {
        // navigate back to parent page (employee form)
        window.location.href = `${returnUrl}?restoreDraft=true`;
      } else {
        // default fallback behavior
        navigate("/hrpayroll/departments");
      }
    } catch (error) {
      modal.warning({
        title: error.message || "Save failed",
      });
    }
  };

  return (
    <div className="department-form">
      <Title
        level={2}
        style={{
          marginBottom: "32px",
          wordBreak: "break-word",
          fontSize: screens.md ? undefined : "20px",
        }}
      >
        {isEditDepartment ? "Update Department" : "Create New Department"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Department Name"
              name="department_name"
              rules={[{ required: true }]}
            >
              <InputField placeholder="Enter Department Name" data-testid="department-name-input" />
            </Form.Item>
          </Flex>
        </Flex>

        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button
            size="large"
            shape="default"
            className="traic-button"
            onClick={handleCancel}
          >
            Back
          </Button>
          {access_type == "WRITE" && <>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="traic-button"
              data-testid="save-department-btn"
            >
              {isEditDepartment ? "Update" : "Save"}
            </Button>
          </>}
        </Flex>
      </Form>
    </div>
  );
};

export default CreateDepartmentForm;
